import React from 'react';
import PropTypes from 'prop-types';
import { StyledLegend, HorizontalRule } from './styles';
import Input from '../field/input';
import CheckboxGroup from '../../input-fields/checkbox-group';
import { country } from '../../../utils/current-site';
import { consentStatement } from '../../form/strings';
import LinkHandler from '../../link-handler';
/**
 * The section of a form that asks the user for consent for using their data for marketing purposes.
 */

const PrivacyNotice = ({ siteName }) => {
  const privacyPaths = {
    England: '/contact_us/privacy',
    Scotland: '/about_us/about_this_website/privacy_policy',
  };

  return (
    <>
      <LinkHandler link={{ path: privacyPaths[siteName] }}>
        Read our privacy policy
      </LinkHandler>{' '}
      for more details.
    </>
  );
};

const Consent = ({ options, formValues }) => {
  const consentName = 'consent';
  const checkboxValues = formValues?.[consentName];
  return (
    <>
      <HorizontalRule />

      <Input name={consentName}>
        <CheckboxGroup
          options={options}
          legend={
            <StyledLegend>
              <strong>{consentStatement}</strong>
            </StyledLegend>
          }
          values={checkboxValues}
          isControlled
        />
      </Input>
      <p>
        You can change your preferences at any time by giving us a call on{' '}
        <a href="tel:03003301234">0300 330 1234</a>, or emailing{' '}
        <a href="mailto:info@shelter.org.uk">info@shelter.org.uk</a>. If you've
        already told us you want to receive updates, we'll keep contacting you
        in the same ways. And don't worry – although Shelter, Shelter Scotland
        and Shelter Trading activities will use your details, we will never pass
        them on to third parties for marketing.{' '}
        <PrivacyNotice siteName={country} />
      </p>
    </>
  );
};

PrivacyNotice.propTypes = {
  siteName: PropTypes.string.isRequired,
};

Consent.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  formValues: PropTypes.object,
};

export default Consent;
